import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export const BRAND = "Se Hospede AKI";

export const useSite = () => {
  const [site, setSite] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/public/site`).then((r) => { cache = r.data; setSite(r.data); }).catch(() => {});
  }, []);
  return site;
};

export const waLink = (phone, text = "") => {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return "";
  const full = digits.length <= 11 ? `55${digits}` : digits;
  return `https://wa.me/${full}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
